import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../service/auth.service';
import {BlogService} from '../../service/blog.service';
import {Blog} from '../../model/Blog';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  imgBlog1 = require('../../../images/blog01.jpg');
  imgBlog2 = require('../../../images/blog02.jpg');
  imgBlog3 = require('../../../images/blog03.jpg');

  blogList: Blog[];
  loading = false;

  constructor(
    private authService: AuthService,
    private blogService: BlogService
  ) { }

  ngOnInit() {
    this.getAllBlogs();
  }

  getAllBlogs() {
    // this.spinnerService.show();
    this.loading = true;
    const x = this.blogService.getBlogs();
    x.snapshotChanges().subscribe(
      (blog) => {
        this.loading = false;
        // this.spinnerService.hide();
        this.blogList = [];
        blog.forEach((element) => {
          const y = element.payload.toJSON();
          y['$key'] = element.key;
          this.blogList.push(y as Blog);
        });
      },
      (err) => {
      //  this.toastrService.error('Error while fetching Blogs', err);
      }
    );
  }

}
